module.exports = __webpack_public_path__ + "01_mustache_silver.d193f3e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/01_mustache_silver.png
// module id = oLjl
// module chunks = 0